<template>
  <slot v-bind="{triggerTippy}"/>
</template>

<script>
import useTippyGuideStore from '@/frontapp/store/tippyGuide'
import { mapStores } from 'pinia'

export default {
  methods: {
    triggerTippy(groupId, enableOverlay = false) {
      this.tippyGuideStore.setCurrentTippyGroup(groupId, enableOverlay)
    },
  },
  computed: {
    ...mapStores( useTippyGuideStore ),
  },
}
</script>

<style lang="scss"></style>
